module.exports = __webpack_public_path__ + "img/numberOfVisitsFirst.9bfa0f0f.svg";